class SearchShop extends HTMLElement {
  minLengthSearch = 2;

  constructor() {
    super();
  }

  connectedCallback() {
    this.map = this.querySelector('mca-map');
    this.init();
  }

  init() {
    this.searchBar = this.querySelector('.search-bar input');
    this.searchBar.addEventListener('input', () => this.search());

    this.getData();

    this.template = {
      searchResult: this.querySelector('#search-result'),
      detail: this.querySelector('#result-detail'),
    };

    this.hasAttribute('data-min-length-search') && (this.minLengthSearch = this.getAttribute('data-min-length-search'));
  }

  search() {
    const value = this.searchBar.value.toLowerCase();
    if (value.length >= this.minLengthSearch) {
      const filteredData = this.data.filter(
        (shop) =>
          shop.name.toLowerCase().includes(value) ||
          (shop.street && shop.street.toLowerCase().includes(value)) ||
          (shop.city && shop.city.toLowerCase().includes(value)) ||
          (shop.postal_code && shop.postal_code.includes(value)) ||
          (shop.locality && shop.locality.toLowerCase().includes(value))
      );
      this.renderResults(filteredData);
    } else {
      this.renderResults([]);
      return;
    }
  }

  getData() {
    const { mapSrc } = this.dataset;
    Papa.parse(mapSrc, {
      download: true,
      header: true,
      complete: (results) => {
        const data = results.data;
        this.data = data.filter((shop) => shop.lat_lng && shop.name);
        this.data.forEach((shop) => {
          const coordData = shop.lat_lng ? shop.lat_lng : null;
          if (!coordData) return;
          const [lat, lng] = coordData.split(',');
          shop.coord = { lat: parseFloat(lat), lng: parseFloat(lng) };
        });
        this.map.createMarkers(this.data);
      },
    });
  }

  renderResults(results) {
    const searchResultContainer = this.querySelector('.search-results');
    const detailContainer = this.querySelector('#selected-shop');

    searchResultContainer.innerHTML = '';
    detailContainer.innerHTML = '';

    // this.map.removeMarkers();
    results.forEach((shop) => {
      const result = document.importNode(this.template.searchResult.content, true);
      const titleElement = result.querySelector('.title');
      const addressElement = result.querySelector('.address');

      if (shop.name && titleElement && addressElement) {
        titleElement.textContent = shop.name;
        addressElement.textContent = `${shop.street} ${shop.street_number},${shop.postal_code} ${shop.locality}, ${shop.city}`;
        result.querySelector('button').addEventListener('click', () => {
          searchResultContainer.innerHTML = '';
          this.showDetail(shop);
        });
        searchResultContainer.appendChild(result);
      } else {
        console.error('Template elements not found');
      }
    });

    if (results.length === 1) {
      this.map.zoomToMarker(results[0].coord.lat, results[0].coord.lng, 15);
    }
    if (results.length === 0) {
      this.map.zoomToMarker(this.map.center[1], this.map.center[0], 7);
    }

    // this.map.createMarkers(results);
  }

  showDetail(shop) {
    const container = this.querySelector('#selected-shop');
    const detail = document.importNode(this.template.detail.content, true);
    const titleElement = detail.querySelector('.selected-shop__title');
    const addressElement = detail.querySelector('.selected-shop__address p');
    const phoneElement = detail.querySelector('.selected-shop__phone p');
    const mapsLink = detail.querySelector('.selected-shop__maps a');

    if (titleElement && addressElement && phoneElement && mapsLink) {
      titleElement.textContent = shop.name;
      addressElement.textContent = `${shop.street} ${shop.street_number}, ${shop.postal_code} ${shop.locality}, ${shop.city}`;
      phoneElement.textContent = shop.phone;
      mapsLink.href = shop.url;
      container.innerHTML = '';
      container.appendChild(detail);

      this.map.zoomToMarker(shop.coord.lat, shop.coord.lng, 15);

      // quand je me deplace sur la map remove container
      this.map.map.on('drag', () => {
        this.removeDetails();
      });
      // this.map.zoomToMarker(shop.coord.lat, shop.coord.lng);
    } else {
      console.error('Template elements not found');
    }
  }

  removeDetails() {
    const searchResultContainer = this.querySelector('.search-results');
    const detailContainer = this.querySelector('#selected-shop');

    searchResultContainer.innerHTML = '';
    detailContainer.innerHTML = '';
  }
}

if (!customElements.get('mca-search-shop')) {
  customElements.define('mca-search-shop', SearchShop);
}
